export function confirmDelete(): boolean {
	return window.confirm(
		"Weet u zeker dat u dit dossier wil verwijderen? Alle gegevens van dit dossier gaan hiermee verloren, inclusief de opgeslagen wijzigingsgeschiedenis. Dit kan invloed hebben op uw wettelijke bewaarplicht als adviseur. Wilt u dit dossier verwijderen?",
	);
}
